import { ComponentProps } from 'react';

import { cn } from '../lib';
import { Label } from './label';
import { RadioGroupItem } from './radio-group';
import { Typography } from './typography';

interface RadioOptionProps {
  value: string;
  title: string;
  radioProps?: Omit<ComponentProps<typeof RadioGroupItem>, 'value'>;
  textProps?: ComponentProps<typeof Typography>;
  className?: string;
}

export function RadioOption({
  value,
  title,
  className,
  textProps,
  radioProps,
}: RadioOptionProps) {
  return (
    <Label
      className={cn(
        'flex h-[72px] w-full items-center justify-between px-4',
        className,
      )}
      htmlFor={value}
    >
      <Typography variant="16-r" {...textProps}>
        {title}
      </Typography>
      <RadioGroupItem value={value} id={value} {...radioProps} />
    </Label>
  );
}
